import { SlideMenu } from 'primereact/slidemenu';

export default SlideMenu;